import { FEATURE_NAME } from './consts';

export const UPDATE_FEED_LAYOUT = `${FEATURE_NAME}/UPDATE_FEED_LAYOUT`;
